import { useState, useCallback } from 'react';
import api from '../Services/api';
import endpointsAdmin from '../Services/endpointAdmin';

/**
 * Custom hook untuk mengambil data riwayat pengajuan.
 *
 * @returns {Object} data, loading, error, fetchAll, fetchByLembaga, fetchById
 */
const useGetRiwayatPengajuan = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const processResponse = (response) => {
    const payload = response?.data;
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (payload.riwayat_pengajuan) return payload.riwayat_pengajuan;
    if (payload.riwayatPengajuan) return payload.riwayatPengajuan;
    if (payload.data) return payload.data;
    if (payload.result) return payload.result;
    return [payload];
  };

  const fetchAll = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.get(endpointsAdmin.riwayat_pengajuan.getAll);
      setData(processResponse(response));
      return response.data;
    } catch (err) {
      const errorMsg = err.response?.data?.message || err.response?.data?.error || err.message || 'Terjadi kesalahan saat memuat riwayat pengajuan';
      setError(errorMsg);
      setData([]);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchByLembaga = useCallback(async (id_lembaga) => {
    if (!id_lembaga) {
      setError('ID lembaga tidak boleh kosong');
      return null;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await api.get(endpointsAdmin.riwayat_pengajuan.getByLembaga(id_lembaga));
      setData(processResponse(response));
      return response.data;
    } catch (err) {
      const errorMsg = err.response?.data?.message || err.response?.data?.error || err.message || 'Terjadi kesalahan saat memuat riwayat pengajuan berdasarkan lembaga';
      setError(errorMsg);
      setData([]);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchById = useCallback(async (id) => {
    if (!id) {
      setError('ID riwayat pengajuan tidak boleh kosong');
      return null;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await api.get(endpointsAdmin.riwayat_pengajuan.getById(id));
      const singleData = processResponse(response);
      setData(singleData);
      return response.data;
    } catch (err) {
      const errorMsg = err.response?.data?.message || err.response?.data?.error || err.message || 'Terjadi kesalahan saat memuat riwayat pengajuan';
      setError(errorMsg);
      setData([]);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    data,
    loading,
    error,
    fetchAll,
    fetchByLembaga,
    fetchById,
  };
};

export default useGetRiwayatPengajuan;
